export default function TS_Special_Types() {
  return (
    <div>
      <h1>TS Special Types</h1>
      <p>This is the TS Special Types page.</p>
    </div>
  );
}